<template>
  <div>
    <b-modal
      ref="modal-route"
      centered
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
    >
      <template #modal-header="">
        <h5>FILE OF USERS</h5>
        <b-button @click="addroute()" class="btnAdd" size="sm" variant="dark">
          <!-- <strong>NEW</strong> -->
          New
        </b-button>
      </template>

      <b-table
        hover
        striped
        select-mode="single"
        small
        sticky-header
        :items="items"
        :fields="fields"
        :busy="isBusy"
        head-variant="dark"
        class="mt-3"
        bordered
        style="max-height: 500px"
        ref="selectableTable"
        selectable
      >
        <template #cell(delete)="row">
          <b-button
            variant="outline-danger"
            @click="promptDelete(row.item, row.index)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>

        <template #cell(edit)="row">
          <b-button @click="editroute(row.item)" variant="outline-success">
            <b-icon icon="pencil"></b-icon>
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <div class="w-100">
          <p class="float-left">
            <strong> Count: {{ count }}</strong>
          </p>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            class="float-right"
            size="sm"
            variant="secondary"
            @click="goHome()"
          >
            go Back
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalEditShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Edit User</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="name"
              v-model="actualuser.nombre"
              disabled
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="User Name"
            label-for="username"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="username"
              v-model="actualuser.username"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Password"
            label-for="password"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="password"
              v-model="actualuser.password"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalEditShow = !modalEditShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="modalAddShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Add New Route</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="User Name:"
            label-for="username"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="username"
              v-model="newuser.username"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Password:"
            label-for="password"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="password"
              v-model="newuser.password"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalAddShow = !modalAddShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "USERS",
  data: function () {
    return {
      url: "https://www.imandrades.com/apiIMA/nomina.php?action=",
      isBusy: false,
      fields: [
        { key: "nombre", label: "Nombre", class: "text-left" },
        { key: "username", label: "User Name", class: "text-left" },
        { key: "delete", class: "text-center" },
        { key: "edit", class: "text-center" },
      ],
      modalEditShow: false,
      modalAddShow: false,
      items: [],
      USERS: [],
      actualuser: {},
      newuser: {},
      count: 0,
      selected: [],
      confirmDelete: "",
      currentroute: "GEORGIA",
      categorySelected: "0",
      colorText: "darkgray",
    };
  },
  mounted() {
    this.$refs["modal-route"].show();
    this.leerUsuarios();
  },
  methods: {
    leerUsuarios: async function () {
      try {
        let respuesta = await axios.get(this.url + "getUsuarios");
        this.users = respuesta.data.usuarios;
        this.items = this.users;
        this.count = this.items.length - 1;
      } catch (error) {
        console.log("Error Leyendo routees");
      }
    },

    goHome() {
      this.$refs["modal-route"].hide();
      this.$router.push("menuDesktop");
    },
    /* onRowSelected() {
      this.selected = items;
      console.log(this.selected);
    }, */
    promptDelete(item, index) {
      console.log("ITEM:", item);
      console.log("INDEX:", index);
      this.confirmDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete user '" + item.nombre + "'",
          {
            title: "Delete route",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          this.confirmDelete = value;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editroute(item) {
      this.actualuser = item;
      this.modalEditShow = true;
    },
    addroute() {
      this.newuser = {};
      this.modalAddShow = true;
    },
    showMsgSave() {
      this.boxTwo = "";
      this.modalEditShow = false;
      this.modalAddShow = false;
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>


<style scoped>
.btnAdd {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.btnAdd:hover {
  transform: scale(1.2);
}
</style>

